<template>
	<ty-input width="100%" type="textarea" rows="1" v-if="type==types.TEXT" :value="value" @input="update" />
	<div v-else-if="type==types.SELECT">
		<p class="fw-300 fs-14" v-if="featureType.restricts_remaining">مقدار این ویژگی در هنگام خرید مشخص می شود</p>
		<!-- <ty-select v-else v-model="content" @change="update">
			<ty-option v-for="t in featureType.options" :key="t.value" :label="t.label" :value="t.value" />
		</ty-select> -->
	</div>
	<div v-else-if="type==types.BOOLEAN">
		<ty-checkbox v-model="content" @input="update"/>
	</div>
	<p v-else-if="type==types.IMAGE">در حال حاضر این بخش محدود می‌باشد</p>
	<div v-else-if="type==types.COLOR" class="ty-flex">
		<ty-color-circle class="my-auto" v-model="content" :editable="true"/>
		<ty-input class="my-auto mr-2" width="152px" placeholder="نام رنگ"/>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: [String, Number],
				default: null
			},
			featureType: {
				type: Object,
				default: null
			}
		},
		data() {
			const {
				value 
			} = this;
			return {
				content: value,
				types: {
					TEXT: 'text',
					SELECT: 'select',
					IMAGE: 'image',
					COLOR: 'color',
					BOOLEAN: 'boolean',
					NUMBER: 'number',
				}
			}
		},
		computed: {
			type() {
				return this.featureType.type
			}
		},
		methods: {
			update (value) {
				this.$emit('input', value);
				this.$emit('change');
				this.$emit('update');
			}
		},
		created() {
			if (this.type == this.types.COLOR && !this.value) this.content = '#f00'
		}
	}
</script>

<style>

</style>